import { channelsText } from './CopyList';
import { Caption, Header, TabStrip, Title } from './styles';
import { formatDateTime } from '../shared/format';
import { CopyParams } from '../useLifecycleUrlState';

import { CopyDetail } from '@/services/lifecycleAPI';

const versionLine = (detail: CopyDetail): string => {
  const latest = detail.history[0];
  if (!detail.version || !latest) {
    return detail.locale === 'es'
      ? 'Spanish: no version yet'
      : 'Default text from the code';
  }
  return `Version ${detail.version} live · published by ${latest.actor_name ?? 'Unknown'}, ${formatDateTime(latest.published_at)}`;
};

const journeyLine = (detail: CopyDetail): string =>
  detail.transactional
    ? 'Transactional'
    : `${detail.journey_key} · ${detail.journey_name}`;

type Props = {
  detail: CopyDetail;
  view: CopyParams['view'];
  onView: (view: CopyParams['view']) => void;
};

const CopyHeader = ({ detail, view, onView }: Props) => (
  <>
    <Header>
      <Title>{detail.label}</Title>
      <Caption>{`${detail.step_key} · ${journeyLine(detail)} · ${channelsText(detail.channels)}`}</Caption>
      <Caption>{versionLine(detail)}</Caption>
    </Header>
    <TabStrip role="tablist">
      <button
        type="button"
        role="tab"
        aria-selected={view === 'edit'}
        data-testid="copyEditTab"
        onClick={() => onView('edit')}
      >
        Edit
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={view === 'history'}
        data-testid="copyHistoryTab"
        onClick={() => onView('history')}
      >
        {`History (${detail.history.length})`}
      </button>
    </TabStrip>
  </>
);

export default CopyHeader;
